import React, { Fragment } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "react-query";
import { ThemeProvider } from "@mui/material";
import Home from "./Home";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ExpoTheme } from "./themes/ExpoTheme";
import ExpoPlannerBuilder from "./ExpoPlannerBuilder";
import RegistrationForm from "./formbuilder/RegistrationForm";
import "react-quill/dist/quill.snow.css";
import AddProductCategories from "./formbuilder/AddProductCategories";
import ChooseCategoryOptions from "./pages/ChooseCategoryOptions";
import RegTemplates from "./formbuilder/templates/RegTemplates";
import TemplateSettings from "./formbuilder/templates/TemplateSettings";
import RegFormContainer from "./formbuilder/container/RegFormContainer";
import ProductCategoriesView from "./pages/ProductCategoriesView";
import CategorySelectorAccordions from "./formbuilder/widgets/CategorySelectorAccordions";
import EmailTemplate from "./formbuilder/templates/EmailTemplate";
import ResgistrationConfirmation from "./pages/ResgistrationConfirmation";
import TermsConditions from "./formbuilder/templates/TermsConditions";
import GtagLoader from "./gtag/GtagLoader";
import GtagRouterTracker from "./gtag/GtagRouterTracker";
import OpenStudentRegistration from "./pages/StudentRegistration";
const queryClient = new QueryClient();
const App = () => {
  return (
    <>
      <GtagLoader />
      <ThemeProvider theme={ExpoTheme}>
        <QueryClientProvider client={queryClient}>
          <Fragment>
            <BrowserRouter>
              <GtagRouterTracker />
              <ToastContainer autoClose={1500} />
              <Routes>
                <Route path="/" element={<ExpoPlannerBuilder />} />
                <Route
                  path="/student-registration"
                  element={<OpenStudentRegistration />}
                />
                <Route
                  path="/visitor-registration"
                  element={<RegFormContainer />}
                />
                <Route
                  path="/registration-confirmation/:id"
                  element={<ResgistrationConfirmation />}
                />
                <Route path="/terms-conditions" element={<TermsConditions />} />
              </Routes>
            </BrowserRouter>
          </Fragment>
        </QueryClientProvider>
      </ThemeProvider>
    </>
  );
};

export default App;
